import DynamicMails from './DynamicMails.vue';
// import disable from './disable.vue';

export default DynamicMails;
